import { useContext } from 'react';
import { useLazyQuery } from '@apollo/client';
import { ExperienceContext } from '~/@thd-nucleus/experience-context';
import getMediaPricingInventoryQuery from '../queries/mediaPriceInventory/getMediaPricingInventoryQuery';
import { useQuery } from './useQuery';

const useMediaPriceInventory = ({
  itemIds,
  storeId,
  includeInventory = false,
  ssr = false,
  lazy = false,
  skip = false
}) => {

  let sId = storeId;
  const ctx = useContext(ExperienceContext);
  if (!sId && ctx && ctx.store) {
    sId = ctx.store.storeId;
  }

  const Query = getMediaPricingInventoryQuery(includeInventory);

  const opts = {
    ssr,
    errorPolicy: 'all',
    skip,
    variables: {
      itemIds,
      storeId: sId,
    }
  };

  if (lazy) {
    return useLazyQuery(Query, opts);
  }
  return useQuery(Query, opts);

};

export default useMediaPriceInventory;
